import {withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import {withRouter} from "react-router";

export const StyledButton = withStyles({
	root: {
		position: 'absolute',
		top: '0',
		left: '5px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#eeeeee',
		paddingBottom: '2px',
		boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
		"&:hover": {
			backgroundColor: '#cacaca'
		}
	},
})(Button);

class GoBack extends React.Component {
	goBack = () => {
		this.props.history.push('/uzitocne-stroje');
	};

	render() {
		return (
			<StyledButton
				onClick={this.goBack}
			>
				&#8629;
			</StyledButton>
		);
	}
}

export default withRouter(GoBack);
